import { connect } from 'react-redux';
//
import CompareDefaultView from 'pages/compare/default-view/default-view';
import { IFieldOption } from 'store/field-options/types';
import { EEvaluationUnit } from 'store/deal-evaluation/types';
import { IDealWithEvaluation } from 'store/deal-comparison/types';
import { IDeal, IDealDataSelector } from 'store/deals/types';
import { IStoreState } from 'store';
import {
  addDealsFromDashboard,
  evaluateDeals,
  removeDeal,
  shiftDealLeft,
  shiftDealRight,
  updateDeals,
  setCompareDealIds,
  removeAllDeals,
} from 'store/deal-comparison/actions';
import { ELoadingType } from 'store/loading/types';
import { setLoading } from 'store/loading/actions';
import { getDealEvaluationData } from './selectors';

export interface ICompareDefaultViewStateProps {
  compareDealIds: string[];
  availableDeals: IDeal[];
  availableProducts?: IFieldOption[];
  dealsWithEvaluation: IDealWithEvaluation[];
  loading: boolean;
  selectedUnitType: EEvaluationUnit;
  dealsData: IDealDataSelector[];
  selectCurrentUnit: string;
}

export interface ICompareDefaultViewDispatchProps {
  addDealsFromDashboard: (deals: IDeal[]) => void;
  evaluateDeals: () => void;
  removeDeal: (index: number) => void;
  shiftDealLeft: (index: number) => void;
  shiftDealRight: (index: number) => void;
  setLoading: (loading: ELoadingType) => void;
  updateDeals: (deal: IDeal) => void;
  removeAllDeals: () => void;
}

export type TCompareDefaultViewProps = ICompareDefaultViewStateProps & ICompareDefaultViewDispatchProps;

const mapStateToProps = (state: IStoreState): ICompareDefaultViewStateProps => ({
  compareDealIds: state.dealComparison.compareDealIds,
  availableDeals: state.deals.data,
  availableProducts: state.fieldOptions.products,
  dealsWithEvaluation: state.dealComparison.dealsWithEvaluation,
  loading: state.loading.loading !== ELoadingType.NONE,
  selectedUnitType: state.dealEvaluation.selectedUnitType,
  dealsData: getDealEvaluationData(state),
  selectCurrentUnit: state.dealEvaluation.selectedCurrentUnitType,
});

const mapDispatchToProps = {
  addDealsFromDashboard,
  evaluateDeals,
  removeDeal,
  shiftDealLeft,
  shiftDealRight,
  setLoading,
  updateDeals,
  setCompareDealIds,
  removeAllDeals,
};

export default connect(mapStateToProps, mapDispatchToProps)(CompareDefaultView);
